/* eslint-disable import/prefer-default-export */
// export const baseUrl = `${window.location.origin}/api`;
// export const baseUrl = "https://uat.edgeonline.co/api";
export const baseUrl = process.env.REACT_APP_API_BASE_URL;
export const s3ImagesBaseURL = process.env.REACT_APP_S3_IMG_BASE_URL;
export const marketplaceBaseUrl = process.env.REACT_APP_MARKETPLACE_BASE_URL;
